export default __webpack_public_path__ + "static/media/tag3Icon.60ad8e0c.svg";